import styles from './index.module.less';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { useUserProvider } from '@/context/UserProvider';
import { useEffect, useState } from 'react';
import { CommonBackContent } from '../Layouts/CommonBackContent';
import { ga_logEvent } from '@/shared/ga';
import { EventName } from '@/shared/event-types';
import { fetchCouponInfo, fetchPaidOrderInfoData, getUserInfo, updateNotifationEmail } from '@/lib/service';
import confetti from 'canvas-confetti';
import dynamic from 'next/dynamic';
import { debounce } from 'lodash-es';
import { CouponInfoModel } from '@/types/coupon';
import dayjs from 'dayjs';
import CommonSimpleModal from '../Common/CommonSimpleModal';
import { Input, message } from 'antd';
import { isApplePrivateEmail, isEmailValid } from '@/shared/utils';
import { UserInfo } from '@/types/home';

const PayFailModal = dynamic(() => import('@/components/PayFailModal/index'), { ssr: false });

const PayResultContent = ({ data }: { data: any }) => {
  const router = useRouter();

  const { success, redirect_url, order_id, canceled, featureType, record_id } = router.query;
  const [payFailModalState, setpayFailModalState] = useState(canceled || false);
  const [show, setShow] = useState(false);
  const { t } = useTranslation('common');
  const { isLogin, onRefreshCouponData } = useUserProvider();
  const [coupon, setCoupon] = useState<CouponInfoModel>(null);
  const [showEditNotiEmail, setShowEditNotiEmail] = useState<boolean>(false);
  const [receiveEmail, setReceiveEmail] = useState<string>(null);
  const [userInfo, setUserInfo] = useState<UserInfo>();

  const imgStr = success === 'true' ? '/images/plan/success-icon.webp' : '/images/plan/failed-icon.webp';
  const resultStr = success === 'true' ? t('PaymentSuccessful') : t('PaymentFailed');
  const btnStr = success === 'true' ? t('Let’s Get Started') : t('TRYAGAIN');

  const fetchPaidInfo = () => {
    if (order_id === undefined) {
      return;
    }
    fetchPaidOrderInfoData(order_id, router.locale).then((res) => {
      if (res?.code == 0) {
        if (!res?.data?.pay_success && res?.data?.pay_link) {
          window.open(res?.data?.pay_link, '_blank');
          return;
        }
        const params = {
          currency: 'USD',
          value: res?.data?.amount,
          items: [
            {
              item_id: res?.data?.order_id,
              item_name: res?.data?.name,
              price: res?.data?.amount,
              quantity: res?.data?.quantity,
            },
          ],
        };
        if (success === 'true') {
          ga_logEvent(EventName.purchase, params);
        } else {
          ga_logEvent(EventName.purchase_fail, params);
        }
      }
    });
  };
  // 关闭弹窗操作
  const handlePayModalClose = () => {
    setpayFailModalState(false);
    setShow(true);
  };

  const getUserInfoAsync = () => {
    getUserInfo()
      .then((res) => {
        if (res?.code === 0) {
          if (
            (res?.data?.receive_email?.length > 0 && isApplePrivateEmail(res?.data?.receive_email)) ||
            isApplePrivateEmail(res?.data?.email)
          ) {
            setShowEditNotiEmail(true);
          }
          setUserInfo(res.data);
        }
      })
      .catch((e) => {});
  };

  const onClick = () => {
    if (isLogin) {
      if (redirect_url != undefined) {
        if (redirect_url.includes('post-comments')) {
          router.replace(`${redirect_url}`);
          return;
        }
        if (record_id || featureType) {
          router.replace(`/dashboard?dashboard_type=toolkit&featureType=${featureType}&record_id=${record_id}`);
          return;
        }
        router.replace(`${redirect_url}`);
      } else {
        router.replace(`/dashboard`);
      }
      fetchPaidInfo();
    } else {
      router.replace('/');
    }
  };
  const fire = (particleRatio: any, opts: any) => {
    var count = 200;
    var defaults = {
      origin: { y: 0.7 },
    };
    confetti({
      ...defaults,
      ...opts,
      particleCount: Math.floor(count * particleRatio),
    });
  };

  const loadCouponData = () => {
    fetchCouponInfo()
      .then((res) => {
        onRefreshCouponData(res?.data);
        setCoupon(res?.data);
      })
      .catch((err) => {
        onRefreshCouponData(null);
        setCoupon(null);
      });
  };

  useEffect(() => {
    const debouncedSearch = debounce(() => {
      if (success === 'true' && isLogin) {
        loadCouponData();
        getUserInfoAsync();
      }
    }, 500);

    debouncedSearch();

    return () => {
      debouncedSearch.cancel();
    };
  }, [success, isLogin]);

  useEffect(() => {
    if (success === 'true') {
      fire(0.25, {
        spread: 26,
        startVelocity: 55,
      });
      fire(0.2, {
        spread: 60,
      });
      fire(0.35, {
        spread: 100,
        decay: 0.91,
        scalar: 0.8,
      });
      fire(0.1, {
        spread: 120,
        startVelocity: 25,
        decay: 0.92,
        scalar: 1.2,
      });
      fire(0.1, {
        spread: 120,
        startVelocity: 45,
      });
    }
  }, []);

  const contentContainer = () => {
    return (
      <div className={styles.content}>
        <Image src={imgStr} width={100} height={100} alt={'result'} loading="lazy" style={{ margin: 'auto' }} />
        <span className={styles.statusTitle}>{resultStr}</span>

        {success === 'true' && (
          <p className={styles.successTip}>
            {t(
              "With your subscription, you can now gain deeper insights by accumulating valuable data. We're excited to support you on this journey!"
            )}
          </p>
        )}

        {/* <Button className={styles.btn} onClick={onClick}>{btnStr}</Button> */}
        <div style={{ display: 'inline-block' }}>
          <div className={styles.btn} onClick={onClick}>
            {btnStr}
          </div>
        </div>
      </div>
    );
  };

  const onConfirmReceiveEmail = () => {
    updateNotifationEmail(receiveEmail)
      .then((res) => {
        if (res.code === 0) {
          message.success(t('Email for notifications updated successfully!'));
          setReceiveEmail(null);
        } else {
          message.error(res?.message);
        }
      })
      .catch((error) => {
        message.error(error?.message);
      });
  };

  return (
    <CommonBackContent style={{ minHeight: '100vh' }}>
      {payFailModalState ? <PayFailModal payFailModalState={payFailModalState} setClose={handlePayModalClose} /> : ''}
      {contentContainer()}

      {/* {coupon?.has_coupon && (
        <PaymentCouponModal
          time={dayjs(coupon?.expire_time).diff(dayjs(), 'millisecond')}
          open={coupon?.has_coupon}
          closeAction={(isOk: boolean) => {
            setCoupon(null);
          }}
        />
      )} */}

      {showEditNotiEmail && (
        <CommonSimpleModal
          open={showEditNotiEmail}
          title={t('Notice')}
          desc={
            <div>
              <p>
                {t(`No email linked. Bind an email to get updates. You can skip now and add it later in`)}
                {` `}
                <a style={{ color: `#725CFF` }} href={'/settings'}>
                  {t('settings')}
                </a>
                .
              </p>
              <Input
                placeholder={t('Email')}
                style={{ marginTop: '20px', marginBottom: '30px' }}
                onChange={(e) => setReceiveEmail(e?.target?.value)}
              />
            </div>
          }
          closeBtnTitle={t('Skip for now')}
          btnTitle={t('Confirm')}
          closeAction={(isOk: boolean) => {
            if (isOk) {
              if (!isEmailValid(receiveEmail)) {
                return message.error(t('Please enter a valid email address'));
              }
              onConfirmReceiveEmail();
            }
            setShowEditNotiEmail(false);
          }}
        />
      )}
    </CommonBackContent>
  );
};

export default PayResultContent;
